import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MapViewerNode, Viewer3dLoadView3dOptionsBasic } from '@3ddv/dvm-internal';
import { ViewersService } from '../../../services/viewers.service';

@Component({
  selector: 'app-popover',
  imports: [],
  templateUrl: './popover.component.html',
  styleUrl: './popover.component.css'
})
export class PopoverComponent implements OnInit {
  @Input() public node: MapViewerNode | null = null;
  public isVisible: boolean = false;
  public isLoading: boolean = false;
  public nodeData: string[] = [];
  public thumbnailSrc: string | null = null;

  constructor(
    private readonly viewersService: ViewersService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    // console.log('PopoverComponent initialized with node:', this.node);

    // Activar la visibilidad después de un breve retraso
    setTimeout(() => {
      this.isVisible = true;
      this.cdr.markForCheck();
    }, 0);

    if (this.node) {
      // Set the node label splitted in section, row and seat, if exists
      this.nodeData = this.node.id.split('_')[1].split('-');
      // Set the thumbnail source
      this.getThumbnail();
    }
  }

  private getThumbnail() {
    // Load the thumbnail
    this.isLoading = true;

    const thumbnailOptions: Viewer3dLoadView3dOptionsBasic = {
      venue_id: this.viewersService.viewer.getVenueId() as string,
      view_id: this.node?.id as string,
    };

    this.viewersService.viewer3d.getThumbnail(thumbnailOptions, true).subscribe({
      next: thumbnail => {
        // console.log('Thumbnail res: ', thumbnail);
        this.thumbnailSrc = thumbnail;
        this.isLoading = false;
        this.cdr.markForCheck();
      },
      error: (err: any) => {
        console.error('Error fetching thumbnail:', err);
      },
    });
  }


}
